import type {PropsWithChildren} from 'react'

export function App(props: PropsWithChildren) {
  return <>{props.children}</>
}

try{ App.displayName ||= 'App' } catch {}